module.exports = __webpack_public_path__ + "assets/img/banner.18209536.jpg";